(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ag-announcement"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-announce][data-rotate]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    if (window.matchMedia('(min-width: 750px)').matches) return;
    const msgs = [...root.querySelectorAll('.ag-announce__msg')];
    if (msgs.length < 2) return;
    let i = 0, timer;
    const show = (n) => { msgs[i].classList.remove('is-active'); i = n; msgs[i].classList.add('is-active'); };
    const tick = () => { timer = setTimeout(() => { show((i + 1) % msgs.length); tick(); }, 5000); };
    tick();
    root.addEventListener('mouseenter', () => clearTimeout(timer));
    root.addEventListener('focusin', () => clearTimeout(timer));
    root.addEventListener('mouseleave', tick);
    root.addEventListener('focusout', tick);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ag-footer"]) return;
  try {
    
(() => {
  document.querySelectorAll('.ag-footer__col-h').forEach((h) => {
    if (matchMedia('(min-width: 750px)').matches) return;
    h.addEventListener('click', () => h.closest('.ag-footer__col').classList.toggle('is-open'));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ag-header"]) return;
  try {
    
(() => {
  document.querySelectorAll('.ag-header').forEach((header) => {
    if (header.dataset.ready) return;
    header.dataset.ready = '1';

    const mega = header.querySelector('[data-mega-panel]');
    const triggers = header.querySelectorAll('[data-mega-trigger]');
    let intentTimer;
    const open = (trigger) => {
      clearTimeout(intentTimer);
      mega.hidden = false;
      requestAnimationFrame(() => mega.classList.add('is-open'));
      triggers.forEach((t) => t.classList.toggle('is-open', t === trigger));
    };
    const close = () => {
      mega.classList.remove('is-open');
      triggers.forEach((t) => t.classList.remove('is-open'));
      setTimeout(() => { if (!mega.classList.contains('is-open')) mega.hidden = true; }, 220);
    };
    triggers.forEach((trigger) => {
      trigger.addEventListener('mouseenter', () => { intentTimer = setTimeout(() => open(trigger), 120); });
      trigger.addEventListener('mouseleave', () => clearTimeout(intentTimer));
      trigger.addEventListener('click', (e) => { e.preventDefault(); mega.classList.contains('is-open') ? close() : open(trigger); });
      trigger.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); open(trigger); } });
    });
    header.addEventListener('mouseleave', close);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    document.addEventListener('focusin', (e) => { if (!header.contains(e.target)) close(); });

    if (header.dataset.hideOnScroll === 'true') {
      let lastY = window.scrollY;
      window.addEventListener('scroll', () => {
        const y = window.scrollY;
        if (y > 200 && y > lastY) header.classList.add('is-hidden');
        else header.classList.remove('is-hidden');
        lastY = y;
      }, { passive: true });
    }

    const searchRoot = header.querySelector('[data-search-root]');
    const panel = header.querySelector('[data-search-panel]');
    const input = header.querySelector('[data-search-input]');
    const results = header.querySelector('[data-search-results]');
    const openSearch = () => { panel.hidden = false; requestAnimationFrame(() => panel.classList.add('is-open')); input.focus(); };
    const closeSearch = () => { panel.classList.remove('is-open'); setTimeout(() => { panel.hidden = true; }, 200); };
    header.querySelectorAll('[data-search-open]').forEach((b) => b.addEventListener('click', openSearch));
    header.querySelectorAll('[data-search-close]').forEach((b) => b.addEventListener('click', closeSearch));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeSearch(); });

    let searchTimer;
    input?.addEventListener('input', () => {
      clearTimeout(searchTimer);
      const q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      searchTimer = setTimeout(async () => {
        try {
          const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection,query&resources[limit]=4`);
          const data = await res.json();
          const products = data?.resources?.results?.products || [];
          results.innerHTML = products.map((p) => `<a href="${p.url}">${p.title}</a>`).join('') || '<p class="ag-meta">No results yet.</p>';
        } catch (err) { /* offline or blocked — fail quiet */ }
      }, 150);
    });
  });

  // Wishlist state shared with card-product.liquid (localStorage key ag_wish)
  const WISH_KEY = 'ag_wish';
  const readWish = () => { try { return JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); } catch (e) { return []; } };
  const writeWish = (list) => { try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) {} };
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    const card = btn.closest('[data-handle]');
    const id = card?.dataset.handle || btn.dataset.handle;
    if (!id) return;
    const list = readWish();
    const next = list.includes(id) ? list.filter((x) => x !== id) : list.concat(id);
    writeWish(next);
    btn.setAttribute('aria-pressed', next.includes(id) ? 'true' : 'false');
  }, true);
  document.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
    const card = btn.closest('[data-handle]');
    const id = card?.dataset.handle || btn.dataset.handle;
    if (id) btn.setAttribute('aria-pressed', readWish().includes(id) ? 'true' : 'false');
  });

  // Open the bag without waiting for the drawer module. Calling open() twice
  // (this listener plus Horizon's on:click) replays the slide and, on a phone,
  // closes and reopens the dialog.
  const showDrawerNow = (drawer) => {
    if (typeof drawer.open === 'function') {
      drawer.open();
      return;
    }
    drawer.setAttribute('open', '');
    const dialog = drawer.querySelector('dialog');
    if (dialog && !dialog.open) {
      const modal = window.matchMedia('(max-width: 989px)').matches;
      if (modal && typeof dialog.showModal === 'function') dialog.showModal();
      else if (typeof dialog.show === 'function') dialog.show();
      else dialog.setAttribute('open', '');
    }
    if (window.matchMedia('(min-width: 990px)').matches) {
      document.querySelector('.page-wrapper')?.classList.add('page-wrapper--drawer-open');
    }
    drawer.dispatchEvent(new CustomEvent('theme-drawer:open', { bubbles: true }));
  };

  document.addEventListener('click', (e) => {
    const bagBtn = e.target.closest('.ag-header__bag, .ag-header__bag-mobile, [data-cart-drawer-toggle]');
    if (!bagBtn) return;
    const drawer = document.querySelector('theme-drawer#cart-drawer');
    if (!drawer) return;
    e.preventDefault();
    e.stopPropagation();
    showDrawerNow(drawer);
  }, true);

  document.addEventListener('click', (e) => {
    const closeBtn = e.target.closest('#cart-drawer .theme-drawer__close-button');
    if (!closeBtn) return;
    const drawer = document.querySelector('theme-drawer#cart-drawer');
    if (!drawer || typeof drawer.close === 'function') return;
    e.preventDefault();
    e.stopPropagation();
    drawer.removeAttribute('open');
    const dialog = drawer.querySelector('dialog');
    if (typeof dialog?.close === 'function' && dialog.open) dialog.close();
    else dialog?.removeAttribute('open');
    document.querySelector('.page-wrapper')?.classList.remove('page-wrapper--drawer-open');
    drawer.dispatchEvent(new CustomEvent('theme-drawer:close', { bubbles: true }));
  }, true);

  // Bag count bump, listened to from anywhere in the theme via: document.dispatchEvent(new CustomEvent('ag:cart-updated', { detail: { count } }))
  const updateBagCount = (rawCount, animate = true) => {
    const raw = parseInt(rawCount, 10);
    const count = (!isNaN(raw) && raw >= 0) ? raw : 0;
    document.querySelectorAll('[data-cart-count-value]').forEach((el) => {
      el.textContent = count;
      if (animate) {
        el.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.15)' }, { transform: 'scale(1)' }], { duration: 250, easing: 'cubic-bezier(.3,1.6,.5,1)' });
      }
    });
  };

  document.addEventListener('ag:cart-updated', (e) => {
    updateBagCount(e.detail?.count, true);
  });

  const syncCartCountFromStorage = () => {
    try {
      // Purge any NaN rendered in DOM
      document.querySelectorAll('[data-cart-count-value]').forEach((el) => {
        const text = el.textContent.trim();
        if (text === 'NaN' || isNaN(parseInt(text, 10))) {
          el.textContent = '0';
        }
      });
      const cached = sessionStorage.getItem('cart-count');
      if (cached) {
        const { value } = JSON.parse(cached);
        const count = parseInt(value, 10);
        if (!isNaN(count) && count >= 0) {
          updateBagCount(count, false);
        } else {
          sessionStorage.removeItem('cart-count');
        }
      }
    } catch (_) {
      sessionStorage.removeItem('cart-count');
    }
  };

  syncCartCountFromStorage();
  window.addEventListener('pageshow', syncCartCountFromStorage);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["complete-look"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-look-add]').forEach((btn) => {
    btn.addEventListener('click', async () => {
      const card = btn.closest('.ag-look__card');
      const items = [...card.querySelectorAll('[data-look-item]:checked')].map((i) => ({ id: i.dataset.variantId, quantity: 1 }));
      if (!items.length) return;
      await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) });
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-split"] && !Shopify.designMode) return;
  try {
    
(() => {
  const roots = document.querySelectorAll('[data-hero-slider]');
  roots.forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const wrap = root.closest('.ag-hero');
    const slides = root.querySelectorAll('.ag-hero__slide');
    const dots = wrap.querySelectorAll('.ag-hero__dots button');
    if (slides.length < 2) return;
    let i = 0;
    const arm = (slide) => {
      slide?.querySelectorAll('img[data-src]').forEach((img) => {
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
      });
    };
    const go = (n) => {
      slides[i].classList.remove('is-active'); dots[i]?.classList.remove('is-active');
      i = n;
      arm(slides[i]);
      slides[i].classList.add('is-active'); dots[i]?.classList.add('is-active');
      arm(slides[(i + 1) % slides.length]);
    };
    arm(slides[1]);
    dots.forEach((d, n) => d.addEventListener('click', () => go(n)));
    if (matchMedia('(prefers-reduced-motion: no-preference)').matches) {
      let timer = setInterval(() => go((i + 1) % slides.length), 6000);
      root.addEventListener('pointerenter', () => clearInterval(timer));
      root.addEventListener('pointerleave', () => { clearInterval(timer); timer = setInterval(() => go((i + 1) % slides.length), 6000); });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["interactive-length-finder"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-ag-length-finder]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  const pills = root.querySelectorAll('.ag-finder-pill');
  const sizeEl = root.querySelector('[data-ag-target-len]');
  const adviceEl = root.querySelector('[data-ag-target-advice]');
  const ctaLen = root.querySelector('[data-ag-cta-len]');
  const cta = root.querySelector('[data-ag-finder-cta]');
  const LENGTH_KEY = 'ag_length';

  // Restore saved choice if available
  const saved = localStorage.getItem(LENGTH_KEY);
  if (saved) {
    const matched = [...pills].find((p) => p.dataset.length === saved);
    if (matched) {
      pills.forEach((p) => p.classList.toggle('is-active', p === matched));
      if (sizeEl) sizeEl.textContent = saved + '″';
      if (adviceEl) adviceEl.textContent = matched.dataset.advice;
      if (ctaLen) ctaLen.textContent = saved + '″';
      if (cta) cta.href = `/collections/all?filter.v.option.length=${saved}`;
    }
  }

  pills.forEach((pill) => {
    pill.addEventListener('click', () => {
      pills.forEach((p) => p.classList.remove('is-active'));
      pill.classList.add('is-active');

      const len = pill.dataset.length;
      const advice = pill.dataset.advice;

      if (sizeEl) sizeEl.textContent = len + '″';
      if (adviceEl) adviceEl.textContent = advice;
      if (ctaLen) ctaLen.textContent = len + '″';
      if (cta) cta.href = `/collections/all?filter.v.option.length=${len}`;

      try {
        localStorage.setItem(LENGTH_KEY, len);
      } catch (e) {}
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // --- AG Commerce additions below (docs/03 §COLLECTION) ---
  (() => {
    const LENGTH_KEY = 'ag_length';

    // In-stock-in-my-length toggle
    const toggleWrap = document.querySelector('[data-ag-instock-toggle]');
    if (toggleWrap) {
      const saved = localStorage.getItem(LENGTH_KEY);
      const btn = toggleWrap.querySelector('[data-ag-toggle-switch]');
      const label = toggleWrap.querySelector('[data-ag-saved-length]');
      if (saved) {
        toggleWrap.hidden = false;
        if (label) label.textContent = saved + '″';
        const params = new URLSearchParams(window.location.search);
        const isOn = params.get('filter.v.option.length') === saved;
        btn.setAttribute('aria-checked', String(isOn));
        btn.addEventListener('click', () => {
          const u = new URL(window.location.href);
          if (btn.getAttribute('aria-checked') === 'true') {
            u.searchParams.delete('filter.v.option.length');
          } else {
            u.searchParams.set('filter.v.option.length', saved);
          }
          window.location.href = u.toString();
        });
      }
    }

    // Length-helper banner
    const bannerForm = document.querySelector('[data-ag-length-form]');
    if (bannerForm) {
      bannerForm.addEventListener('submit', (e) => {
        e.preventDefault();
        const value = new FormData(bannerForm).get('height');
        if (!value) return;
        localStorage.setItem(LENGTH_KEY, value);
        const u = new URL(window.location.href);
        u.searchParams.set('filter.v.option.length', value);
        window.location.href = u.toString();
      });
    }

    // "Showing N of M" progress — recomputed as infinite scroll appends cards.
    const grid = document.querySelector('.product-grid');
    const total = Number(document.querySelector('results-list')?.dataset.resultsCount) ||
      document.querySelectorAll('.product-grid__item').length;
    const update = () => {
      const shown = document.querySelectorAll('.product-grid__item').length;
      const fill = document.querySelector('.ag-progress__fill');
      const label = document.querySelector('.ag-progress-label');
      if (!fill || !label || !total) return;
      fill.style.width = Math.min(100, (shown / total) * 100) + '%';
      label.textContent = `Showing ${shown} of ${total}`;
    };
    const mount = () => {
      if (!grid || document.querySelector('.ag-progress-label')) return;
      const wrap = document.createElement('div');
      wrap.innerHTML = '<div class="ag-progress"><div class="ag-progress__fill"></div></div><p class="ag-progress-label"></p>';
      grid.after(wrap);
      update();
    };
    if (grid) {
      mount();
      new MutationObserver(update).observe(grid, { childList: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  const roots = document.querySelectorAll('[data-ag-pdp]');
  roots.forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';

    // Parse media list
    let mediaList = [];
    try {
      mediaList = JSON.parse(root.querySelector('[data-ag-media-json]')?.textContent || '[]');
    } catch (e) {}

    let currentMediaIndex = 0;
    const heroImg = root.querySelector('[data-ag-hero-img]');
    const heroFrame = heroImg?.closest('.ag-pdp__hero-frame') || root.querySelector('.ag-pdp__hero-frame');
    const thumbs = root.querySelectorAll('[data-ag-thumb]');
    const mobileTrack = root.querySelector('[data-ag-mobile-track]');
    const mobileShots = root.querySelectorAll('[data-ag-mobile-shot]');
    const dots = root.querySelectorAll('.ag-pdp__dot');

    const fileOf = (url) => (url || '').split('?')[0].split('/').pop().toLowerCase();
    const indexForUrl = (url) => {
      const file = fileOf(url);
      if (!file) return -1;
      return mediaList.findIndex((item) => fileOf(item.src) === file || fileOf(item.zoom) === file);
    };
    const preloaded = new Set();
    const preloadUrl = (url) => {
      if (!url || preloaded.has(url)) return;
      preloaded.add(url);
      const img = new Image();
      img.decoding = 'async';
      img.src = url;
    };
    const preloadColour = (colour) => {
      const want = (colour || '').trim().toLowerCase();
      thumbs.forEach((thumb) => {
        const shot = (thumb.dataset.shotColour || '').trim().toLowerCase();
        if (!want || shot === want) {
          preloadUrl(thumb.querySelector('img')?.getAttribute('src'));
          preloadUrl(thumb.dataset.imgSrc);
          preloadUrl(thumb.dataset.zoomSrc);
        }
      });
    };
    const colourPool = () => {
      const current = (thumbs[currentMediaIndex]?.dataset.shotColour || '').trim().toLowerCase();
      const pool = [];
      thumbs.forEach((thumb, index) => {
        if (thumb.classList.contains('is-colour-hidden')) return;
        const shot = (thumb.dataset.shotColour || '').trim().toLowerCase();
        if (!current || !shot || shot === current) pool.push(index);
      });
      return pool.length ? pool : [...thumbs].map((_, index) => index);
    };

    const updateActiveMedia = (index) => {
      if (index < 0 || index >= mediaList.length) return;
      currentMediaIndex = index;
      const mediaItem = mediaList[index];

      thumbs.forEach((thumb, i) => {
        const isActive = i === index;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-selected', String(isActive));
        if (isActive) thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });

      if (heroImg && mediaItem) {
        heroImg.style.opacity = '';
        if (heroImg.getAttribute('src') !== mediaItem.src) heroImg.src = mediaItem.src;
        heroImg.alt = mediaItem.alt || '';
        heroImg.dataset.zoomSrc = mediaItem.zoom || mediaItem.src;
      }
      if (heroFrame) heroFrame.dataset.index = String(index);

      if (mobileShots[index]) {
        mobileShots.forEach((shot, i) => shot.classList.toggle('is-active', i === index));
        if (mobileTrack) {
          mobileShots[index].scrollIntoView({ inline: 'nearest', block: 'nearest' });
        }
      }
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    };

    // Thumbnail Clicks
    thumbs.forEach((t) => {
      const warm = () => preloadUrl(t.dataset.imgSrc);
      t.addEventListener('pointerenter', warm, { passive: true });
      t.addEventListener('focus', warm);
      t.addEventListener('click', () => {
        const idx = Number(t.dataset.index || 0);
        preloadUrl(t.dataset.imgSrc);
        updateActiveMedia(idx);
      });
    });
    const initialColour = [...thumbs].find((thumb) => thumb.classList.contains('is-active'))?.dataset.shotColour
      || [...thumbs].find((thumb) => !thumb.classList.contains('is-colour-hidden'))?.dataset.shotColour
      || '';
    preloadColour(initialColour);
    const warmRest = () => thumbs.forEach((thumb) => {
      preloadUrl(thumb.querySelector('img')?.getAttribute('src'));
      preloadUrl(thumb.dataset.imgSrc);
    });
    if ('requestIdleCallback' in window) requestIdleCallback(warmRest);
    else setTimeout(warmRest, 400);

    // Opened with ?variant= (e.g. from the Black Abayas listing): start on that colourway's photo.
    const startShot = [...mobileShots].findIndex((shot) => shot.classList.contains('is-active'));
    if (startShot > 0) {
      currentMediaIndex = startShot;
      if (mobileTrack) mobileTrack.scrollLeft = mobileShots[startShot].offsetLeft - mobileTrack.offsetLeft;
    }

    // Single-Image Lightbox
    // Single-Image Lightbox with Touch Gestures & Zoom
    const dialog = root.parentElement.querySelector('[data-ag-lightbox]');
    const lightboxImg = dialog?.querySelector('[data-ag-lightbox-single-img]');
    const lightboxCounter = dialog?.querySelector('[data-ag-lightbox-counter]');
    const prevBtn = dialog?.querySelector('[data-ag-lightbox-prev]');
    const nextBtn = dialog?.querySelector('[data-ag-lightbox-next]');
    const stage = dialog?.querySelector('.ag-pdp__lightbox-stage') || lightboxImg;

    let currentScale = 1;
    let panX = 0;
    let panY = 0;
    let touchStartX = 0;
    let touchStartY = 0;
    let touchStartTime = 0;
    let initialPinchDist = null;
    let initialPinchScale = 1;
    let lastTapTime = 0;

    const resetZoom = () => {
      currentScale = 1;
      panX = 0;
      panY = 0;
      if (lightboxImg) {
        lightboxImg.style.transition = 'transform 0.25s ease, opacity 0.15s ease';
        lightboxImg.style.transform = 'translate3d(0, 0, 0) scale(1)';
        lightboxImg.style.cursor = 'zoom-in';
      }
    };

    const applyTransform = (smooth = false) => {
      if (!lightboxImg) return;
      lightboxImg.style.transition = smooth ? 'transform 0.25s cubic-bezier(0.16, 1, 0.3, 1)' : 'none';
      lightboxImg.style.transform = `translate3d(${panX}px, ${panY}px, 0) scale(${currentScale})`;
      lightboxImg.style.cursor = currentScale > 1 ? 'grab' : 'zoom-in';
    };

    const showLightboxIndex = (index) => {
      if (!mediaList.length) return;
      const pool = colourPool();
      let pos = pool.indexOf(index);
      if (pos === -1) pos = 0;
      resetZoom();
      currentMediaIndex = pool[pos];
      const item = mediaList[currentMediaIndex];
      if (lightboxImg && item) {
        lightboxImg.style.opacity = '';
        const nextSrc = item.zoom || item.src;
        if (lightboxImg.getAttribute('src') !== nextSrc) lightboxImg.src = nextSrc;
        lightboxImg.alt = item.alt || '';
      }
      if (lightboxCounter) lightboxCounter.textContent = `${pos + 1} / ${pool.length}`;
      updateActiveMedia(currentMediaIndex);
    };

    root.querySelectorAll('[data-ag-zoom-open]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const shown = btn.querySelector('img');
        const fromSrc = indexForUrl(shown?.currentSrc || shown?.getAttribute('src'));
        const idx = fromSrc >= 0 ? fromSrc : Number(btn.dataset.index || currentMediaIndex || 0);
        showLightboxIndex(idx);
        dialog?.showModal();
      });
    });

    const stepLightbox = (dir) => {
      const pool = colourPool();
      const pos = pool.indexOf(currentMediaIndex);
      const next = pool[(Math.max(pos, 0) + dir + pool.length) % pool.length];
      showLightboxIndex(next);
    };
    prevBtn?.addEventListener('click', (e) => { e.stopPropagation(); stepLightbox(-1); });
    nextBtn?.addEventListener('click', (e) => { e.stopPropagation(); stepLightbox(1); });

    dialog?.querySelectorAll('[data-ag-lightbox-close]').forEach((closeBtn) => {
      closeBtn.addEventListener('click', () => {
        resetZoom();
        dialog.close();
      });
    });

    dialog?.addEventListener('click', (e) => {
      if (e.target === dialog) {
        resetZoom();
        dialog.close();
      }
    });

    window.addEventListener('keydown', (e) => {
      if (!dialog?.open) return;
      if (e.key === 'ArrowLeft') stepLightbox(-1);
      if (e.key === 'ArrowRight') stepLightbox(1);
      if (e.key === 'Escape') resetZoom();
    });

    // Desktop Click to Toggle Zoom
    lightboxImg?.addEventListener('click', (e) => {
      e.stopPropagation();
      if (currentScale > 1) {
        resetZoom();
      } else {
        const rect = lightboxImg.getBoundingClientRect();
        const originX = ((e.clientX - rect.left) / rect.width) * 100;
        const originY = ((e.clientY - rect.top) / rect.height) * 100;
        lightboxImg.style.transformOrigin = `${originX}% ${originY}%`;
        currentScale = 2.2;
        applyTransform(true);
      }
    });

    // Mobile Touch Gestures: Pinch-to-zoom, Double-tap zoom, Touch Swipe & Pull-to-dismiss
    if (stage) {
      stage.addEventListener('touchstart', (e) => {
        if (e.touches.length === 1) {
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
          touchStartTime = Date.now();
        } else if (e.touches.length === 2) {
          const dx = e.touches[0].clientX - e.touches[1].clientX;
          const dy = e.touches[0].clientY - e.touches[1].clientY;
          initialPinchDist = Math.hypot(dx, dy);
          initialPinchScale = currentScale;
        }
      }, { passive: true });

      stage.addEventListener('touchmove', (e) => {
        if (e.touches.length === 2 && initialPinchDist) {
          // Pinch Zoom
          const dx = e.touches[0].clientX - e.touches[1].clientX;
          const dy = e.touches[0].clientY - e.touches[1].clientY;
          const dist = Math.hypot(dx, dy);
          currentScale = Math.min(Math.max(initialPinchScale * (dist / initialPinchDist), 1), 3.5);
          applyTransform(false);
          e.preventDefault();
        } else if (e.touches.length === 1) {
          const curX = e.touches[0].clientX;
          const curY = e.touches[0].clientY;
          const deltaX = curX - touchStartX;
          const deltaY = curY - touchStartY;

          if (currentScale > 1) {
            // Panning when zoomed in
            panX += deltaX * 0.8;
            panY += deltaY * 0.8;
            touchStartX = curX;
            touchStartY = curY;
            applyTransform(false);
            e.preventDefault();
          } else {
            // Swiping when scale == 1
            if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 8) {
              lightboxImg.style.transition = 'none';
              lightboxImg.style.transform = `translate3d(${deltaX * 0.65}px, 0, 0) scale(1)`;
              if (Math.abs(deltaX) > 12) e.preventDefault();
            } else if (deltaY > 0) {
              // Pull down
              lightboxImg.style.transition = 'none';
              lightboxImg.style.transform = `translate3d(0, ${deltaY * 0.55}px, 0) scale(${1 - Math.min(0.2, deltaY / 1000)})`;
            }
          }
        }
      }, { passive: false });

      stage.addEventListener('touchend', (e) => {
        if (e.touches.length === 0) {
          initialPinchDist = null;

          if (currentScale > 1) {
            const maxPan = 100 * (currentScale - 1);
            panX = Math.max(-maxPan, Math.min(maxPan, panX));
            panY = Math.max(-maxPan, Math.min(maxPan, panY));
            applyTransform(true);
          } else {
            const touchEndX = e.changedTouches[0].clientX;
            const touchEndY = e.changedTouches[0].clientY;
            const deltaX = touchEndX - touchStartX;
            const deltaY = touchEndY - touchStartY;
            const elapsed = Date.now() - touchStartTime;

            // Double tap zoom
            const now = Date.now();
            if (now - lastTapTime < 300 && Math.abs(deltaX) < 15 && Math.abs(deltaY) < 15) {
              lastTapTime = 0;
              const rect = lightboxImg.getBoundingClientRect();
              const originX = ((touchEndX - rect.left) / rect.width) * 100;
              const originY = ((touchEndY - rect.top) / rect.height) * 100;
              lightboxImg.style.transformOrigin = `${originX}% ${originY}%`;
              currentScale = currentScale > 1 ? 1 : 2.5;
              panX = 0;
              panY = 0;
              applyTransform(true);
              return;
            }
            lastTapTime = now;

            // Swipe navigation
            const isFlick = elapsed < 320 && Math.abs(deltaX) > 35;
            const isLongSwipe = Math.abs(deltaX) > 60;

            if ((isFlick || isLongSwipe) && Math.abs(deltaX) > Math.abs(deltaY)) {
              if (deltaX < 0) stepLightbox(1);
              else stepLightbox(-1);
            } else if (deltaY > 80) {
              resetZoom();
              dialog?.close();
            } else {
              resetZoom();
            }
          }
        }
      });
    }

    // Mobile scroll indicator tracking
    if (mobileTrack && dots.length) {
      mobileTrack.addEventListener('scroll', () => {
        const scrollLeft = mobileTrack.scrollLeft;
        const width = mobileTrack.offsetWidth || 1;
        const idx = Math.min(dots.length - 1, Math.max(0, Math.round(scrollLeft / (width * 0.88))));
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === idx));
      }, { passive: true });
    }

    // Variant Resolver & Switcher
    const buybox = root.querySelector('[data-ag-buybox-col]');
    const atc = buybox?.querySelector('[data-ag-atc]');
    const lengthBlock = root.querySelector('[data-ag-length-block]');
    const variantInput = buybox?.querySelector('input[name="id"]');
    const priceWrap = buybox?.querySelector('.ag-pdp-price');
    const priceEl = priceWrap?.querySelector('.price, .price-item--sale');
    const stockLine = buybox?.querySelector('[data-ag-stock-line]');
    const stickyBar = document.querySelector('[data-ag-sticky-atc]');
    const stickyMeta = stickyBar?.querySelector('[data-ag-sticky-meta]');
    const LENGTH_KEY = 'ag_length';

    let variants = [];
    let optionsMeta = [];
    try { variants = JSON.parse(root.querySelector('[data-ag-variants]')?.textContent || '[]'); } catch (e) {}
    try { optionsMeta = JSON.parse(root.querySelector('[data-ag-options]')?.textContent || '[]'); } catch (e) {}

    const optionGroups = [...root.querySelectorAll('[data-ag-option-group]')];
    const selected = {};
    optionGroups.forEach((group) => {
      const pos = Number(group.dataset.optionPosition);
      const checkedBtn = group.querySelector('[data-ag-option-btn].is-selected, [data-ag-option-btn]:checked');
      if (checkedBtn) selected[pos] = checkedBtn.dataset.optionValue ?? checkedBtn.value;
    });

    const currentVariant = () => variants.find((v) => String(v.id) === String(variantInput?.value));
    const findVariant = () => {
      const current = currentVariant();
      return variants.find((v) => optionsMeta.every((o) => {
        const want = selected[o.position] ?? current?.[`option${o.position}`];
        return want == null || v[`option${o.position}`] === want;
      }));
    };

    const formatMoney = (cents) => {
      const sample = priceEl?.textContent.trim() || '';
      const prefixMatch = sample.match(/^[^\d]*/);
      const prefix = prefixMatch ? prefixMatch[0] : '₹';
      return `${prefix}${(cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;
    };

    const render = () => {
      const v = findVariant();
      if (!v) return;

      if (variantInput) { variantInput.value = v.id; variantInput.dispatchEvent(new Event('change', { bubbles: true })); }

      if (priceEl) priceEl.textContent = formatMoney(v.price);

      if (atc) {
        atc.disabled = !v.available;
        atc.dataset.agAtcState = v.available ? 'ready' : 'oos';
        const label = atc.querySelector('[data-ag-atc-label]');
        if (label) label.textContent = v.available ? `Add to bag · ${formatMoney(v.price)}` : 'Notify me when back';
      }

      const lengthValueLabel = lengthBlock?.querySelector('[data-ag-length-value]');
      const lengthPos = optionsMeta.find((o) => /length|size/i.test(o.name))?.position;
      const lengthOpt = optionsMeta.find((o) => o.position === lengthPos);
      const lengthUnit = lengthOpt?.name === 'Length' ? '″' : '';
      const optionWord = lengthOpt?.name === 'Length' ? 'length' : 'size';

      if (stockLine && !stockLine.hasAttribute('data-ag-mto-stock')) {
        if (!v.available) {
          stockLine.dataset.agStock = 'out';
          stockLine.textContent = `This ${optionWord} is unavailable in this colour.`;
        } else {
          const low = v.inventory_management === 'shopify' && v.inventory_quantity > 0 && v.inventory_quantity <= 3;
          stockLine.dataset.agStock = low ? 'low' : 'in';
          const picked = selected[lengthPos] || v.title.split(' / ').pop();
          stockLine.textContent = low ? `Only ${v.inventory_quantity} left in ${picked}${lengthUnit}` : 'In stock · Ready to dispatch';
        }
      }

      if (lengthValueLabel && lengthPos) lengthValueLabel.textContent = `${selected[lengthPos]}${lengthUnit}`;
      const lengthHint = lengthBlock?.querySelector('[data-ag-length-hint]');
      if (lengthHint && lengthPos && lengthOpt?.name === 'Length') {
        const bands = { '52': '5′0″ – 5′1″', '54': '5′2″ – 5′3″', '56': '5′4″ – 5′5″', '58': '5′6″ – 5′7″', '60': '5′8″ – 5′9″' };
        const band = bands[String(selected[lengthPos])];
        lengthHint.textContent = band
          ? `For height ${band}. Heels of 2.5″ or higher: choose one length longer.`
          : 'Lengths are measured shoulder to hem. Heels of 2.5″ or higher: choose one length longer.';
      }

      const colourValueLabel = root.querySelector('[data-ag-option-group] [data-ag-option-value]');
      const colourPos = optionsMeta.find((o) => o.name === 'Colour')?.position;
      if (colourValueLabel && colourPos) colourValueLabel.textContent = selected[colourPos];

      // Re-check availability of every length tile against selected colour
      const lengthGroup = optionGroups.find((g) => /length|size/i.test(g.dataset.optionName));
      if (lengthGroup) {
        lengthGroup.querySelectorAll('[data-ag-length-tile]').forEach((tile) => {
          const btn = tile.querySelector('[data-ag-option-btn]');
          const trial = { ...selected, [lengthGroup.dataset.optionPosition]: btn.dataset.optionValue ?? btn.value };
          const match = variants.find((mv) => optionsMeta.every((o) => mv[`option${o.position}`] === trial[o.position]));
          tile.classList.toggle('is-unavailable', !!match && !match.available);
        });
      }

      if (colourPos && selected[colourPos]) {
        const curColour = selected[colourPos].trim().toLowerCase();
        preloadColour(curColour);
        const colourNodes = [
          ...thumbs,
          ...root.querySelectorAll('[data-ag-mobile-shot]'),
          ...root.querySelectorAll('[data-ag-dot]'),
        ];
        const tagged = colourNodes.filter((node) => (node.dataset.shotColour || '').trim());
        const visibleMatches = tagged.filter((node) => node.dataset.shotColour.trim().toLowerCase() === curColour);
        const filterOn = visibleMatches.length > 0;
        colourNodes.forEach((node) => {
          const shot = (node.dataset.shotColour || '').trim().toLowerCase();
          node.classList.toggle('is-colour-hidden', filterOn && shot !== '' && shot !== curColour);
        });

        const already = thumbs[currentMediaIndex]
          && !thumbs[currentMediaIndex].classList.contains('is-colour-hidden')
          && (thumbs[currentMediaIndex].dataset.shotColour || '').trim().toLowerCase() === curColour;
        if (!already) {
          const first = [...thumbs].find((thumb) => (thumb.dataset.shotColour || '').trim().toLowerCase() === curColour);
          if (first) updateActiveMedia(Number(first.dataset.index));
        }
      }

      if (stickyMeta) stickyMeta.textContent = `${lengthPos ? selected[lengthPos] + lengthUnit : ''}${lengthPos && colourPos ? ' · ' : ''}${colourPos ? selected[colourPos] : ''} · ${formatMoney(v.price)}`;
      const stickyLabel = stickyBar?.querySelector('[data-ag-sticky-label]');
      if (stickyLabel) stickyLabel.textContent = v.available ? `Add to bag · ${formatMoney(v.price)}` : 'Notify me when back';
      const stickyBtn = stickyBar?.querySelector('[data-ag-sticky-atc-btn]');
      if (stickyBtn) stickyBtn.disabled = !v.available;

      if (lengthPos) { try { localStorage.setItem(LENGTH_KEY, String(selected[lengthPos])); } catch (e) {} }
    };

    optionGroups.forEach((group) => {
      const pos = Number(group.dataset.optionPosition);
      group.querySelectorAll('[data-ag-option-btn]').forEach((ctrl) => {
        const evt = ctrl.tagName === 'INPUT' ? 'change' : 'click';
        ctrl.addEventListener(evt, () => {
          selected[pos] = ctrl.dataset.optionValue ?? ctrl.value;
          group.querySelectorAll('[data-ag-option-btn]').forEach((other) => {
            const isThis = other === ctrl;
            other.classList.toggle('is-selected', isThis);
            if (other.tagName === 'BUTTON') other.setAttribute('aria-pressed', String(isThis));
          });
          render();
        });
      });
    });

    // Restore saved length on load
    try {
      const saved = localStorage.getItem(LENGTH_KEY);
      const lengthGroup = optionGroups.find((g) => /length|size/i.test(g.dataset.optionName));
      if (saved && lengthGroup) {
        const btn = [...lengthGroup.querySelectorAll('[data-ag-option-btn]')].find((b) => (b.dataset.optionValue ?? b.value) === saved);
        if (btn && !btn.classList.contains('is-selected') && !btn.checked) {
          btn.checked = true;
          btn.dispatchEvent(new Event(btn.tagName === 'INPUT' ? 'change' : 'click'));
        }
      }
    } catch (e) {}

    // Shake + scroll to length selector when ATC is disabled and clicked
    atc?.addEventListener('click', (e) => {
      if (atc.disabled && lengthBlock) {
        e.preventDefault();
        lengthBlock.scrollIntoView({ behavior: 'smooth', block: 'center' });
        atc.classList.remove('is-shake'); void atc.offsetWidth; atc.classList.add('is-shake');
      }
    });

    // Sticky ATC bar via IntersectionObserver on the real buy button
    if (atc && stickyBar && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([entry]) => {
        stickyBar.hidden = false;
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      }, { threshold: 0 });
      io.observe(atc);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-look"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-look-add]').forEach((btn) => {
    if (btn.dataset.ready) return; btn.dataset.ready = '1';
    btn.addEventListener('click', async () => {
      const wrap = btn.closest('.ag-plook');
      const items = [...wrap.querySelectorAll('[data-look-item]:checked')].map((i) => ({ id: i.dataset.variantId, quantity: 1 }));
      if (!items.length) return;
      await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) });
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-rail"] && !Shopify.designMode) return;
  try {
    
customElements.define('product-rail', class extends HTMLElement {
  connectedCallback() {
    const track = this.querySelector('[data-rail-grid]');
    this.querySelector('[data-rail-prev]')?.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth * 0.9, behavior: 'smooth' }));
    this.querySelector('[data-rail-next]')?.addEventListener('click', () => track.scrollBy({ left: track.clientWidth * 0.9, behavior: 'smooth' }));
    this.querySelectorAll('[data-rail-tab]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        if (btn.classList.contains('is-active')) return;
        this.querySelectorAll('[data-rail-tab]').forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        const handle = btn.dataset.collection;
        const sectionId = this.dataset.sectionId;
        try {
          const res = await fetch(`/collections/${handle}?section_id=${sectionId}`);
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newGrid = doc.querySelector('[data-rail-grid]');
          if (newGrid) track.innerHTML = newGrid.innerHTML;
        } catch (e) { /* leave current grid in place on failure */ }
      });
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-ag-wishlist-page]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  const KEY = 'ag_wish';
  const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } };
  const write = (list) => { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} };

  const grid = root.querySelector('[data-wish-grid]');
  const empty = root.querySelector('[data-wish-empty]');
  const countEl = root.querySelector('[data-wish-count]');
  const template = root.querySelector('[data-wish-card-template]');
  const LOW_STOCK = Number(root.dataset.lowStock || 3);

  async function render() {
    const handles = read();
    countEl.textContent = handles.length ? `(${handles.length})` : '';
    grid.innerHTML = '';
    if (!handles.length) { empty.toggleAttribute('data-visible', true); return; }
    empty.toggleAttribute('data-visible', false);

    const products = await Promise.all(handles.map(async (handle) => {
      try {
        const res = await fetch(`/products/${handle}.js`);
        if (!res.ok) return null;
        return await res.json();
      } catch (e) { return null; }
    }));

    products.forEach((product, i) => {
      if (!product) return;
      const handle = handles[i];
      const node = template.content.firstElementChild.cloneNode(true);
      node.href = `/products/${handle}`;
      const img = node.querySelector('[data-wish-img], img');
      if (product.featured_image) { img.src = product.featured_image.replace(/\.(\w+)(\?|$)/, '_720x.$1$2'); img.alt = product.title; }
      node.querySelector('[data-wish-title]').textContent = product.title;
      node.querySelector('[data-wish-price]').textContent = formatMoney(product.price);

      const variant = product.variants[0];
      const flag = node.querySelector('[data-wish-flag]');
      const cta = node.querySelector('[data-wish-cta]');
      const anyAvailable = product.variants.some((v) => v.available);
      if (!anyAvailable) {
        flag.hidden = false; flag.textContent = 'Sold out'; flag.className = 'ag-badge ag-badge--muted ag-wish__flag';
        cta.textContent = 'Notify me'; cta.dataset.action = 'notify';
      } else if (variant && variant.inventory_management && variant.inventory_quantity > 0 && variant.inventory_quantity <= LOW_STOCK) {
        flag.hidden = false; flag.textContent = `Only ${variant.inventory_quantity} left`; flag.className = 'ag-badge ag-badge--sale ag-wish__flag';
        cta.textContent = 'Move to bag'; cta.dataset.action = 'add'; cta.dataset.variantId = variant.id;
      } else {
        cta.textContent = 'Move to bag'; cta.dataset.action = 'add'; cta.dataset.variantId = variant ? variant.id : '';
      }

      node.querySelector('[data-wish-remove]').addEventListener('click', (e) => {
        e.preventDefault(); e.stopPropagation();
        write(read().filter((h) => h !== handle));
        render();
      });
      cta.addEventListener('click', (e) => {
        e.preventDefault(); e.stopPropagation();
        if (cta.dataset.action === 'add' && cta.dataset.variantId) addToCart(cta.dataset.variantId, cta);
        else window.location.href = `/products/${handle}`;
      });

      grid.appendChild(node);
    });
  }

  function formatMoney(cents) {
    return '₹' + Math.round(cents / 100).toLocaleString('en-IN');
  }

  async function addToCart(variantId, btn) {
    const original = btn.textContent;
    btn.textContent = 'Adding…'; btn.disabled = true;
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });
      btn.textContent = 'Added ✓';
      document.dispatchEvent(new CustomEvent('ag:cart-updated', { detail: {} }));
      setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1800);
    } catch (e) {
      btn.textContent = original; btn.disabled = false;
    }
  }

  root.querySelector('[data-wish-add-all]').addEventListener('click', () => {
    grid.querySelectorAll('[data-wish-cta][data-action="add"]').forEach((btn) => btn.click());
  });
  root.querySelector('[data-wish-share]').addEventListener('click', async () => {
    try {
      if (navigator.share) await navigator.share({ title: 'My Ayşe Güzel wishlist', url: window.location.href });
      else { await navigator.clipboard.writeText(window.location.href); root.querySelector('[data-wish-share]').textContent = 'Link copied'; }
    } catch (e) { /* user cancelled */ }
  });

  render();
})();

  } catch(e) { console.error(e); }
})();
})();
